import I18n from 'I18n';
import { PlaylistForm } from './PlaylistForm';
import { useCreatePlaylist, useFullPlaylist } from '../savedItemsQueries';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { getPlaylistUrl } from '../../playlist/playlistRouting';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import UsageTracker from 'academy-common-lib/utils/UsageTracker';
import { isInternalContent } from 'academy-common-lib/features/learningContent/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DuplicatePlaylistNotification = ({
  playlistId
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.savedItems.tooltips.duplicatedPlaylist"
    }), /*#__PURE__*/_jsx(TFlex, {
      align: "center",
      gap: 6,
      paddingBlockStart: "300",
      children: /*#__PURE__*/_jsx(RouterButton, {
        size: "small",
        to: getPlaylistUrl(playlistId),
        use: "secondary-ghost",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyCommon.savedItems.tooltips.viewPlaylist"
        })
      })
    })]
  });
};
export const DuplicatePlaylistModal = ({
  playlistId,
  onRequestClose
}) => {
  const skipFetchingPlaylist = !playlistId;
  const {
    playlist,
    playlistLoading
  } = useFullPlaylist(playlistId, skipFetchingPlaylist);
  const {
    createPlaylist,
    createPlaylistError,
    createPlaylistLoading
  } = useCreatePlaylist({
    onCompleted(newPlaylist) {
      var _playlist$items$some, _playlist$items;
      UsageTracker.trackStandalone('Playlist Interaction', {
        action: 'playlist-duplicated',
        isCustom: (_playlist$items$some = playlist === null || playlist === void 0 || (_playlist$items = playlist.items) === null || _playlist$items === void 0 ? void 0 : _playlist$items.some(isInternalContent)) !== null && _playlist$items$some !== void 0 ? _playlist$items$some : false
      });
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(DuplicatePlaylistNotification, {
          playlistId: newPlaylist.id
        }),
        type: 'success'
      });
      onRequestClose();
    }
  });
  const onSubmit = values => {
    if (!playlist) {
      return;
    }
    createPlaylist({
      name: values.name,
      description: values.description,
      items: playlist.items.map(item => ({
        itemId: item.itemId,
        type: item.type,
        language: item.language
      }))
    }).catch(() => {
      FloatingAlertStore.addAlert({
        message: I18n.text('academyCommon.savedItems.tooltips.savePlaylistError'),
        type: 'danger'
      });
    });
  };
  const onCancel = () => {
    UsageTracker.trackStandalone('Playlist Interaction', {
      action: 'close-create-modal'
    });
  };
  const playlistTitle = (playlist === null || playlist === void 0 ? void 0 : playlist.name) && I18n.text('academyCommon.playlists.duplicatedPlaylistTitle', {
    playlistTitle: I18n.SafeString(playlist.name)
  });
  return /*#__PURE__*/_jsx(PlaylistForm, {
    error: createPlaylistError,
    formLoadedMarker: null,
    initialValues: {
      name: playlistTitle || '',
      description: (playlist === null || playlist === void 0 ? void 0 : playlist.description) || ''
    },
    loading: createPlaylistLoading || playlistLoading,
    onCancel: onCancel,
    onRequestClose: onRequestClose,
    onSubmit: onSubmit,
    submitButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.common.duplicate"
    }),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.playlists.duplicatePlaylist"
    })
  });
};